<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
	<div id="page-user-view" class="data-list-container">


			<div class="mb-6 grid md:grid-cols-2" v-if="chartLoaded">
				<div>
					<div slot="header" class="w-full mb-4 flex">
						<label style="color: black; font-size: 18px; font-weight: bold;">Thống kê nhân viên Khai Báo / Chưa khai báo trong ngày</label>
					</div>
					<highcharts :options="chartOptions"></highcharts>
				</div>
				<div>
					<div slot="header" class="w-full mb-4 flex">
						<label style="color: black; font-size: 18px; font-weight: bold;">Thống kê tình trạng</label>
					</div>
					<highcharts :options="pieChartOptions"></highcharts>
				</div>
				<!-- <div style="height: 420px; overflow: auto;" v-if="$store.state.moduleUser && $store.state.moduleUser.users3">
					<vs-table :sst="true" class="shadow-none border-none" :data="$store.state.moduleUser && $store.state.moduleUser.users3">
						<div slot="header" class="w-full mb-4 flex">
							<label style="color: black; font-size: 18px; font-weight: bold;">Danh sách nhân viên chưa khai báo trong ngày</label>
						</div>
						<template slot="thead">
							<vs-th class="w-px" sort-key="fullname"><h6 class="uppercase font-bold">STT</h6></vs-th>
							<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Nhân viên</h6></vs-th>
							<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Điện thoại</h6></vs-th>
							<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Đơn vị</h6></vs-th>
							<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Lần khai báo cuối</h6></vs-th>
						</template>

						<template slot-scope="{ data }">
							<vs-tr :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickItemRow($event, tr)">
								<vs-td>
									<p :class="{'word-break': 1}">
										{{ indextr+1 }}
									</p>
								</vs-td>
								<vs-td class="lg:w-64">
									<p :class="{'word-break': 1, uppercase: 1}">
										{{ tr.hoten }}
									</p>
								</vs-td>
								<vs-td>
									<p :class="{'word-break': 1}">
										{{ tr.sdt }}
									</p>
								</vs-td>
								<vs-td>
									<p :class="{'word-break': 1}">
										{{ tr.congty }}
									</p>
								</vs-td>
								<vs-td>
									<p :class="{'word-break': 1}">
										{{ $helper.momentFormatLocale(tr.created_at, 'DD/MM/YYYY', 7) }}
									</p>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</div> -->
			</div>

		<vs-table :sst="true" class="shadow-none border-none" :data="$store.state.moduleUser && $store.state.moduleUser.users" @sort="handleSort">
			<div slot="header" class="w-full mb-12 flex">
				<h4 class="font-bold">Thống kê</h4>
				<div class="flex flex-grow justify-end">
					<vs-input @input="handleSearch" size="large" class="input-search mr-3 md:block lg:block xl:block hidden" icon="search" :placeholder="'Tìm theo SĐT'" v-model="searchText" />
					
					<div class="relative inline-flex">
						<svg class="w-2 h-2 absolute top-0 right-0 m-4 pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 412 232"><path d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z" fill="#648299" fill-rule="nonzero"/></svg>
						<select v-model="filterCa" class="border border-gray-300 rounded text-gray-600 h-10 pl-5 pr-10 bg-white hover:border-gray-400 focus:outline-none appearance-none" style="border: 1px solid rgba(0, 0, 0, 0.2);">
							<option value="0">Tất cả ca/giờ làm</option>
							<option :value="idx" :key="idx" v-for="(work, idx) in workShifts">{{work}}</option>
						</select>
					</div>
				</div>
			</div>

			<template slot="thead">
				<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Mã phiếu</h6></vs-th>
				<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Tên nhân viên</h6></vs-th>
				<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Số điện thoại</h6></vs-th>
				<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Đơn vị</h6></vs-th>
				<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Ca/Giờ làm</h6></vs-th>
				<vs-th sort-key="fullname"><h6 class="uppercase font-bold">Lần khai báo gần nhất</h6></vs-th>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :set="highlight=getHighlight(tr)" :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickItemRow($event, tr)" :style="{ backgroundColor: getColor(tr) ? getColor(tr) : (indextr%2==0 ? 'transparent' : '#fff') }" >
					<vs-td>
						<p :class="{'tr-highlight': highlight, 'word-break': 1}">
							{{ ('000000' + tr.maphieu).slice(-6) }}
						</p>
					</vs-td>
					<vs-td>
						<p :class="{'tr-highlight': highlight, 'word-break': 1, uppercase: 1}">
							{{ tr.hoten }}
							<!-- <sup :style="{color: 'orange', fontWeight: 'bold'}" v-if="tr.status != 2">F{{tr.status}}</sup> -->
						</p>
					</vs-td>
					<vs-td>
						<p :class="{'tr-highlight': highlight, 'word-break': 1}">
							{{ tr.sdt }}
						</p>
					</vs-td>
					<vs-td>
						<p :class="{'tr-highlight': highlight, 'word-break': 1}">
							{{ tr.congty }}
						</p>
					</vs-td>
					<vs-td>
						<p :class="{'tr-highlight': highlight, 'word-break': 1}">
							{{ $helper.locateWorkShift(tr.ca) }}
						</p>
					</vs-td>
					<vs-td>
						<p :class="{'tr-highlight': highlight, 'word-break': 1}">
							{{ $helper.momentFormatLocale(tr.created_at, 'DD/MM/YYYY HH:mm', 7) }}
						</p>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
		<div class="w-full center mt-4">
			<CbsPagination :total="total" v-model="page"></CbsPagination>
		</div>
		<UserDetail v-if="isDetailUserDialogActive" :data="detailUserDialogData" :isSidebarActive="isDetailUserDialogActive" @closeSidebar="toggleDetailSidebar" />
	</div>
</template>

<script>
import CbsPagination from "@/components/cbs-pagination/CbsPagination";
import UserDetail from "./UserDetail.vue";

import {Chart} from 'highcharts-vue'
import Helpers from '../../../utils/helpers';

export default {
	components: {
		CbsPagination, UserDetail,
		highcharts: Chart 
	},
	data() {
		return {
			workShifts: Helpers.getWorkShifts(),
			filterCa: 0,
			chartLoaded: false,
			countingStar: 0,
			intervalObj: null,
			listUser: [],
			page: 1,
			searchText: "",
			userDialog: false,
			userData: {},
			detailUserDialogData: null,
			isDetailUserDialogActive: false,
			isDetailUserCustomerDialogActive: false,
			filters: {
				isTechnic: true,
				ca: 0
			},

			chartOptions: {
				chart: {
					type: 'column'
				},
				title: {
					text: ''
				},
				series: [],
				xAxis: {
					categories: []
				},
				yAxis: {
					min: 0,
					title: {
						text: 'Tổng số nhân viên'
					},
					stackLabels: {
						enabled: true,
						style: {
							fontWeight: 'bold',
							color: 'gray'
						}
					}
				},
				legend: {
					align: 'right',
					x: -30,
					verticalAlign: 'top',
					y: 25,
					floating: true,
					backgroundColor: 'white',
					borderColor: '#CCC',
					borderWidth: 1,
					shadow: false
				},
				tooltip: {
					headerFormat: '<b>{point.x}</b><br/>',
					pointFormat: '{series.name}: {point.y}<br/>Tổng: {point.stackTotal}'
				},
				plotOptions: {
					column: {
						stacking: 'normal',
						dataLabels: {
							enabled: true
						}
					}
				}
			},
			pieChartOptions: {
				chart: {
					plotBackgroundColor: null,
					plotBorderWidth: null,
					plotShadow: false,
					type: 'pie'
				},
				title: {
					text: ''
				},
				// tooltip: {
				// 	pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
				// },
				tooltip: {
					pointFormat: 'Tỉ lệ: {point.percentage:.1f} %<br>Tổng cộng: {point.y}'
				},
				accessibility: {
					point: {
						valueSuffix: '%'
					}
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						dataLabels: {
							enabled: true,
							format: '<b>{point.name}</b>: {point.percentage:.1f} %'
						}
					}
				},
				series: [{
					name: 'Tình trạng',
					colorByPoint: true,
					data: []
				}]
			}
		};
	},
	computed: {
		total() {
			return Math.ceil(this.$store.state.moduleUser.total / this.$store.state.moduleUser.limit);
		}
	},
	methods: {
		getColor(tr) {
			let status = parseInt(tr.status);
			let color = '';
			switch (status) {
				case 1: {
					color = '#92d050';
					break;
				}
				case 2: {
					color = '#FFFF00';
					break;
				}
				case 3: {
					color = '#ff6d01';
					break;
				}
				case 4: {
					color = '#FF0000';
					break;
				}
			}
			return color;
		},
		getHighlight(tr) {
			return false;
			return ((tr.trieuchung && JSON.stringify(tr.trieuchung).indexOf('true') > 0) || (tr.lichtrinh && tr.lichtrinh.length > 130)) ? true : false;
		},
		async getGetUsers() {
			this.$vs.loading();
			this.filters.ca = this.filterCa;
			const payload = {
				filters: this.filters,
				sort: this.sort,
				projection: {
					email: 1,
					fullname: 1,
					overview: 1
				},
				paging: {
					page: this.page,
					limit: this.$store.state.moduleUser.limit
				}
			};
			try {
				await this.$store.dispatch("moduleUser/fetchUsers", payload);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
				console.log(error.message);
			}
		},
		async getGetUsers3() {
			this.$vs.loading();
			const payload = {
				filters: this.filters,
				sort: this.sort,
				projection: {
					email: 1,
					fullname: 1,
					overview: 1
				},
				paging: {
					page: this.page,
					limit: this.$store.state.moduleUser.limit
				}
			};
			try {
				// this.$store.dispatch("moduleUser/fetchUsers3", payload);
				let response = await this.$store.dispatch("moduleUser/fetchUsers3", payload);
				if (response && response.data) {
					this.pieChartOptions.series[0].data = response.data;
				}
				this.chartLoaded = true;
				this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
			}
		},
		handleSearch() {
			this.filters = { fullname: this.searchText };
			this.getGetUsers();
		},
		openUserForm(user) {
			if (user) {
				this.editUser(user);
			} else {
				this.addNewUser();
			}
		},
		addNewUser() {
			this.userData = {};
			this.toggleUserDialog(true);
		},
		editUser(user) {
			// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
			this.userData = user;
			this.toggleUserDialog(true);
		},

		toggleUserDialog(val = false) {
			this.userDialog = val;
		},
		showDeleteUserConfirm(user) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteUser(user._id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async deleteUser(userId) {
			this.$vs.loading();
			try {
				await this.$store.dispatch("moduleUser/removeRecord", userId);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		async getTongQuan(userId) {
			this.$vs.loading();
			try {
				let response = await this.$store.dispatch("moduleUser/exportData", userId);
				if (response && response.data && response.data.data) {
					let cats = response.data.data.categories;
					if (Array.isArray(cats)) {
						this.chartOptions.plotOptions.column.stacking = cats.length > 1 ? 'normal' : undefined;
						// cats.sort();
					}
					this.chartOptions.xAxis.categories = cats;
					this.chartOptions.series = response.data.data.series;
				}
				this.chartLoaded = true;
				this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				this.chartLoaded = true;
				this.$vs.loading.close();
			}
		},
		handleClickItemRow(event, user) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find(className => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
				this.detailUserDialogData = user;
				this.toggleDetailSidebar(true);
			}
		},
		toggleDetailSidebar(val = false) {
			this.isDetailUserDialogActive = val;
		},
		toggleUserCustomerSidebar(val = false) {
			this.isDetailUserCustomerDialogActive = val;
		},
		handleSort(key, active) {
			const _key = key;// `_id.${key}`;
			this.sort = {};
			this.sort[_key] = active === "asc" ? 1 : -1;
			this.getGetUsers();
		},
		assignedZones(assignedZones) {
			// let _assignedZone = "";
			// Update property in user
			// assignedZones.map(assignedZone => {
			// 	_assignedZone = _assignedZone + (assignedZone.name + ", ");
			// });
			return assignedZones.reduce((zones, zone) => {
				zones += zone && zone.name ? `${zones ? ', ': ''}${zone.name}` : '';
				return zones;
			}, '');
			// _assignedZone = _assignedZone.slice(0, _assignedZone.lastIndexOf(","));
			// return _assignedZone;
		},
		showCustomerByUser(user) {
			this.detailUserCustomerDialogData = user;
			this.toggleUserCustomerSidebar(true);
		}
	},
	watch: {
		page() {
			this.getGetUsers();
		},
		searchText() {
			this.getGetUsers();
		},
		filterCa() {
			console.log(this.filterCa);
			this.page = 1;
			this.getGetUsers();
		}
	},
	created() {
		// Register Module UserManagement Module
		this.getTongQuan(1);
		this.getGetUsers3();
		this.getGetUsers();
		

		this.intervalObj = setInterval(() => {
			let rmI = document.querySelector('.highcharts-credits');
			if (rmI) {
				rmI.remove();
			}
			this.countingStar++;
			if (this.countingStar > 30) {
				clearInterval(this.intervalObj);
			}
		}, 1000);
	}
};
</script>

<style lang="scss">
.tr-highlight {
	font-weight: bold;
	color: blue;
}
.nguyhiem {
	background-color: #f5e6e6 !important;
}
#avatar-col {
	width: 10rem;
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		// &:not(.permissions-table) {
		// 	td {
		// 		@media screen and (max-width: 370px) {
		// 			display: block;
		// 		}
		// 	}
		// }
	}
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px), only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}

	// #account-manage-buttons {
	//   width: 12rem !important;
	//   flex-direction: column;

	//   > button {
	//     margin-right: 0 !important;
	//     margin-bottom: 1rem;
	//   }
	// }
}
</style>
